import { LifeCycle } from './lifeCycle';

export const AllActivityStates = ['Live', 'Paused', 'Scheduled', 'Finished', 'Archived', 'Testing', 'Migration'];
export type ActivityState = typeof AllActivityStates[number];

const isAfterStartTime = (lifeCycle: LifeCycle, time: number): boolean => {
  return !lifeCycle.startTime || time > lifeCycle.startTime;
};

const isBeforeEndTime = (lifeCycle: LifeCycle, time: number): boolean => {
  return !lifeCycle.endTime || time < lifeCycle.endTime;
};

const isInWindow = (lifeCycle: LifeCycle, time: number): boolean => {
  return isAfterStartTime(lifeCycle, time) && isBeforeEndTime(lifeCycle, time);
};

export const getActivityState = (lifeCycle: LifeCycle): ActivityState => {
  switch (lifeCycle.state) {
    case 'ACTIVE':
      const now = Date.now();
      if (isInWindow(lifeCycle, now)) {
        return 'Live';
      }

      if (isAfterStartTime(lifeCycle, now)) {
        return 'Finished';
      }
      return 'Scheduled';

    case 'INACTIVE':
      return 'Paused';

    case 'TESTING':
      return 'Testing';

    case 'DELETED':
      return 'Archived';

    case 'MIGRATION':
      return 'Migration';
  }
};

export const getCampaignSubState = (lifeCycle: LifeCycle) => {
  if (lifeCycle.state !== 'ACTIVE') {
    return lifeCycle.state;
  }
  const now = Date.now();
  if (isInWindow(lifeCycle, now)) {
    return 'ACTIVE';
  }

  if (isAfterStartTime(lifeCycle, now)) {
    return 'FINISHED';
  }
  return 'SCHEDULED';
};

export const getGradientVariation = (lifeCycle: LifeCycle) => {
  switch (lifeCycle.state) {
    case 'ACTIVE':
      const now = Date.now();
      if (isInWindow(lifeCycle, now)) {
        return 'live';
      }
      if (isAfterStartTime(lifeCycle, now)) {
        return 'finished';
      }
      return 'scheduled';
    case 'TESTING':
      return 'test';
    case 'MIGRATION':
      return 'migration';
    case 'INACTIVE':
      return 'paused';
    case 'DELETED':
      return 'archived';
    case 'SCHEDULED':
      return 'scheduled';
    case 'FINISHED':
      return 'finished';
  }
};
